import T from "../theme/colors";

export default function Badge({ label, size = "sm" }) {
  const MAP = {
    ACTIVE:           { bg: "var(--success-bg)",  color: "var(--success)", bdr: "var(--success-bdr)" },
    active:           { bg: "var(--success-bg)",  color: "var(--success)", bdr: "var(--success-bdr)" },
    true:             { bg: "var(--success-bg)",  color: "var(--success)", bdr: "var(--success-bdr)" },
    INACTIVE:         { bg: "var(--bg-app)",    color: "var(--text-2)",   bdr: "var(--border)"     },
    inactive:         { bg: "var(--bg-app)",    color: "var(--text-2)",   bdr: "var(--border)"     },
    false:            { bg: "var(--bg-app)",    color: "var(--text-2)",   bdr: "var(--border)"     },
    DRAFT:            { bg: "var(--warn-bg)",     color: "var(--warn)",    bdr: "var(--warn-bdr)"    },
    SENT:             { bg: "var(--info-bg)",     color: "var(--info)",    bdr: "var(--info-bdr)"    },
    REVISED:          { bg: "var(--purple-bg)",   color: "var(--purple)",  bdr: "var(--purple-bdr)"  },
    COMPLETED:        { bg: "var(--success-bg)",  color: "var(--success)", bdr: "var(--success-bdr)" },
    ACCEPTED:         { bg: "var(--success-bg)",  color: "var(--success)", bdr: "var(--success-bdr)" },
    REJECTED:         { bg: "var(--danger-bg)",   color: "var(--danger)",  bdr: "var(--danger-bdr)"  },
    CONFIRMED:        { bg: "var(--success-bg)",  color: "var(--success)", bdr: "var(--success-bdr)" },
    PARTIAL_RECEIVED: { bg: "var(--warn-bg)",     color: "var(--warn)",    bdr: "var(--warn-bdr)"    },
    FULLY_RECEIVED:   { bg: "var(--success-bg)",  color: "var(--success)", bdr: "var(--success-bdr)" },
    CANCELLED:        { bg: "var(--danger-bg)",   color: "var(--danger)",  bdr: "var(--danger-bdr)"  },
    RETAIL:           { bg: "var(--primary-light)",color: "var(--primary)", bdr: "var(--primary-dim)" },
    WHOLESALE:        { bg: "var(--info-bg)",     color: "var(--info)",    bdr: "var(--info-bdr)"    },
    GOVERNMENT:       { bg: "var(--purple-bg)",   color: "var(--purple)",  bdr: "var(--purple-bdr)"  },
    CORPORATE:        { bg: "var(--success-bg)",  color: "var(--success)", bdr: "var(--success-bdr)" },
    CR:               { bg: "var(--success-bg)",  color: "var(--success)", bdr: "var(--success-bdr)" },
    DR:               { bg: "var(--danger-bg)",   color: "var(--danger)",  bdr: "var(--danger-bdr)"  },
    default:          { bg: "var(--bg-app)",    color: "var(--text-1)",   bdr: "var(--border)"     },
  };
  const key = String(label ?? "");
  const cfg = MAP[key] || MAP.default;
  const text = key.replace(/_/g, " ");

  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 5,
      background: cfg.bg, color: cfg.color,
      border: `1px solid ${cfg.bdr}`,
      padding: size === "sm" ? "2px 8px" : "4px 10px",
      borderRadius: 5,
      fontSize: size === "sm" ? 11 : 12,
      fontWeight: 600,
      letterSpacing: "0.04em",
      textTransform: "uppercase",
      whiteSpace: "nowrap",
      fontFamily: "var(--font-ui)",
    }}>
      <span style={{ width: 5, height: 5, borderRadius: "50%", background: cfg.color, flexShrink: 0 }} />
      {text}
    </span>
  );
}